/**
 * @generated SignedSource<<3ea3a52d6d4349f0d92562f6b4a2c062>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreviewRoomRateInput = {
  roomPriceAdult: number;
  roomPriceChild: number;
};
export type RoomRatesTableRateEditorFormQuery$variables = {
  input: PreviewRoomRateInput;
  packageDateId: string;
  preview?: boolean | null;
};
export type RoomRatesTableRateEditorFormQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_data">;
};
export type RoomRatesTableRateEditorFormQuery = {
  response: RoomRatesTableRateEditorFormQuery$data;
  variables: RoomRatesTableRateEditorFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "packageDateId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "preview"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoomRatesTableRateEditorFormQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "preview",
            "variableName": "preview"
          }
        ],
        "kind": "FragmentSpread",
        "name": "RoomRatesTableRateEditorForm_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoomRatesTableRateEditorFormQuery",
    "selections": [
      {
        "condition": "preview",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              },
              {
                "kind": "Variable",
                "name": "packageDateId",
                "variableName": "packageDateId"
              }
            ],
            "concreteType": "RoomRate",
            "kind": "LinkedField",
            "name": "previewRoomRate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tripPriceAdult",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tripPriceChild",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baseCostAdult",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baseCostChild",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPercentMarkup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "markupPercentAdult",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "markupPercentChild",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "markupAmountAdult",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "markupAmountChild",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c250fbf31ce20b54d447972fd076f97d",
    "id": null,
    "metadata": {},
    "name": "RoomRatesTableRateEditorFormQuery",
    "operationKind": "query",
    "text": "query RoomRatesTableRateEditorFormQuery(\n  $input: PreviewRoomRateInput!\n  $packageDateId: ID!\n  $preview: Boolean = false\n) {\n  ...RoomRatesTableRateEditorForm_data_LbG1U\n}\n\nfragment RoomRatesTableRateEditorForm_data_LbG1U on Query {\n  previewRoomRate(packageDateId: $packageDateId, input: $input) @include(if: $preview) {\n    ...RoomRatesTableRateEditorPriceBreakdown_roomRate\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorPriceBreakdown_roomRate on RoomRate {\n  tripPriceAdult\n  tripPriceChild\n  baseCostAdult\n  baseCostChild\n  isPercentMarkup\n  markupPercentAdult\n  markupPercentChild\n  markupAmountAdult\n  markupAmountChild\n}\n"
  }
};
})();

(node as any).hash = "65c043bf3d48bebf728e1843d007c201";

export default node;
